<template>
    <VcFormItem
        ref="elFormItemRef"
        :rules="rules"
        :label="label"
        :icon="icon"
        :prop="prop"
        :label-width="labelWidth"
        :required="required"
        :info-text="infoText"
        class="base-form-item"
        :data-test="`form-item-${prop}`"
        :data-testid="`form-item-${prop}`"
        v-bind="$attrs"
    >
        <slot />
    </VcFormItem>
</template>

<script setup lang="ts">
import { TranslateResult } from 'vue-i18n'
import { VcFormItem } from '@voicenter-team/voicenter-ui-plus'

interface IFIProps {
    required?: boolean
    label?: string | TranslateResult
    icon?: string
    error?: string
    infoText?: string | TranslateResult
    labelWidth?: string
    infoTooltipWidth?: string | number
    rules?: Array<object>
    prop?: string | Array<string>
    size?: 'medium' | 'small' | 'mini'
}

const props = withDefaults(defineProps<IFIProps>(), {
    required: false,
    label: '',
    icon: '',
    infoText: '',
    labelWidth: 'auto',
    size: 'small',
    infoTooltipWidth: '',
    error: undefined,
    rules: () => [],
    prop: undefined
})
</script>

<style lang="scss">
    .base-form-item {
        .el-form-item__label {
            padding: 0 0 8px !important;
        }
    }
</style>
